/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import { DSBanner } from '../index.js';
import type { DSBannerT } from '../index.js';

// test we expose the namespace and the namespace follows our deliverable conventions
type ComponentPropsForApp = DSBannerT.Props;
type ComponentPropsInternals = DSBannerT.InternalProps;
type ComponentPropsDefaultProps = DSBannerT.DefaultProps;
type ComponentPropsOptionalProps = DSBannerT.OptionalProps;
type ComponentPropsRequiredProps = DSBannerT.RequiredProps;

const testRequiredProps: ComponentPropsRequiredProps = {};
const testOptionalProps: ComponentPropsOptionalProps = {
  actionLink: {
    label: 'test',
    onClick: () => {},
    href: 'test',
  },
  CustomBody: () => <div>test</div>,
  closeBtnRef: () => null,
  actionRef: { current: {} },
};

// difference Props and InternalProps is that InternalProps has all the default props filled in
//  Props allows for partial defaults
const testPartialDefaults: Partial<ComponentPropsDefaultProps> = {
  label: 'hello',
};
const testProps: ComponentPropsForApp = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
};
const testPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testPartialDefaults,
} as ComponentPropsForApp;
// InternalProps requires all defaults to be filled in
const testCompleteDefaults: Required<ComponentPropsDefaultProps> = {
  containerProps: {},
  label: '',
  body: '',
  type: 'info',
  isOpen: true,
  onClose: () => null,
  showCloseButton: true,
  withLiveRegionAnnouncement: 'alert',
  isPageNotice: false,
};
const testInternalProps: ComponentPropsInternals = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
};
const testInternalPropsAsSyntax = {
  ...testRequiredProps,
  ...testOptionalProps,
  ...testCompleteDefaults,
} as ComponentPropsInternals;

// using the explicit type definition, if there is an error, it will be marked on the key that is wrong
const testExplicitDefinition: ComponentPropsForApp = {
  label: '',
  body: '',
  type: 'info',
  isOpen: true,
  withLiveRegionAnnouncement: 'alert',
  isPageNotice: false,
};

// using the "as" syntax, if there is an error, it will be marking the whole object as wrong because it is not compatible with the type
const testInferedTypeCompatibility = {
  label: '',
  body: '',
  type: 'info',
  isOpen: true,
  withLiveRegionAnnouncement: 'alert',
  isPageNotice: false,
} as ComponentPropsForApp;

const testDefinitionAsConst = {
  label: '',
  body: '',
  type: 'info',
  isOpen: true,
  withLiveRegionAnnouncement: 'alert',
  isPageNotice: false,
} as const;

const ExampleUsageComponent = () => (
  <>
    {/* works with explicitly casted props, all syntaxes */}
    <DSBanner {...testExplicitDefinition} />
    <DSBanner {...testInferedTypeCompatibility} />
    <DSBanner {...testDefinitionAsConst} />
    {/* works with inline values */}
    <DSBanner label="hello" body="body" type="danger" isOpen />
  </>
);
